/* eslint-disable react/no-children-prop */
import React, { Fragment, useState } from 'react';
import {
  Card, CardBody, Row, Col, ButtonToolbar, Button
} from 'reactstrap';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';

import { Tooltip } from '@material-ui/core';
import MuiButton from '@material-ui/core/Button';

import { Field, reduxForm, getFormValues, change } from 'redux-form';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import moment from 'moment';

import Modal from '../../../shared/components/Modal';

import TrialSubscribe from './../../../shared/components/payment/TrialSubscribe';
import ChangePlan from '../../../shared/components/payment/ChangePlan';
import PremiumCreditsPurchaseModal from '../../../shared/components/premium_credits/PremiumCreditsPurchaseModal';
import PremiumCreditIcon from 'mdi-react/PlusCircleMultipleOutlineIcon';
import CoinIcon from 'mdi-react/StarCircleOutlineIcon';
import{
	_capitalizeText,
	_formatNumber
} from '../../../shared/helpers/utils';

import { subscriptionPlans, appFeatures, DataCreditUsageProgress, getCreditsAllowed } from '../../../shared/components/payment/plans.js';



const required = value => value ? undefined : 'Required'
const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined
const maxLength15 = maxLength(15)
const number = value => value && isNaN(Number(value)) ? 'Must be a number' : undefined
const minValue = min => value =>
  value && value < min ? `Must be at least ${min}` : undefined
const minValue18 = minValue(18)
const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
  'Invalid email address' : undefined

const renderTextField = ({
  input, label, meta: { touched, error, warning }, children, select,
}) => (
  <Fragment>
	  <TextField
	    className="material-form__field"
	    label={label}
	    error={touched && error}
	    value={input.value}
	    children={children}
	    select={select}
	    onChange={(e) => {
	      e.preventDefault();
	      input.onChange(e.target.value);
	    }}
	    type="password"
	  />
	  {touched && ((error && <div className="field-error">{error}</div>) || (warning && <div className="field-error warn">{warning}</div>))}
  </Fragment>
);

renderTextField.propTypes = {
  input: PropTypes.shape().isRequired,
  label: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  select: PropTypes.bool,
  children: PropTypes.arrayOf(PropTypes.element),
};

renderTextField.defaultProps = {
  label: '',
  meta: null,
  select: false,
  children: [],
};

const DataUsage = ( props ) => {

	const [ modalOpen, setModalOpen ] = useState(false);
	const [ subscribe, setSubscribe ] = useState(false);
	const [ planOpen, setPlanOpen ] = useState(false);

	const { cancelSubscription, reset, user, subscription, reactivateSubscription, userCreditUsed } = props;
	const { subscriptionPlan } = user;
	const currentPlan = subscriptionPlans.filter(plan => plan.stripeProductId === subscriptionPlan)[0];

	const creditsAllowed = getCreditsAllowed(user);

	// Standard tokens usage
	const tokensUsed = userCreditUsed || 0;
	let tokensRemaining = creditsAllowed - tokensUsed;
	if (tokensRemaining < 0) {
		tokensRemaining = 0;
	}

	// Premium credits balance
	let premiumCreditsBalance = 0;
	if (typeof user.premiumCredits === 'number') {
		premiumCreditsBalance = user.premiumCredits;
	}


	return(
		<Col md={12} lg={12}>
			<Card className="billing">
				<CardBody>
					<div>
						<h5 className="bold-text card__title mb-1">
							<CoinIcon size={36} /> Token Usage
						</h5>
						<hr />
					</div>

					{/* Two cards side by side: Pipeline Tokens / Premium Credits */}
					<Row>
						{/* Pipeline Tokens card */}
						<Col md={6} className="mb-3">
							<Card>
								<CardBody className="billing-credits__card">
									<div className="billing-credits__header">
										<h6 className="billing-credits__section-title">
											Pipeline Tokens
										</h6>
										<span className="billing-credits__badge">
											Resets Monthly
										</span>
									</div>

									<p className="billing-credits__section-description">
										Pipeline Tokens are <strong>included with your Pipeline plan</strong>. You receive a set amount each billing month that covers standard data exports. When the billing month resets, <strong>your tokens reset</strong> as well.
									</p>
									<hr />
									<div className="billing-credits__summary">
										<div className="billing-credits__stat">
											<div className="billing-credits__stat-label">Included In Your Plan</div>
											<div className="billing-credits__stat-value">
												{_formatNumber(creditsAllowed)}
											</div>
											<div className="billing-credits__stat-sub">
												total tokens
											</div>
										</div>

										<div className="billing-credits__stat">
											<div className="billing-credits__stat-label">Used</div>
											<div className="billing-credits__stat-value">
												{_formatNumber(tokensUsed)}
											</div>
											<div className="billing-credits__stat-sub">
												so far this month
											</div>
										</div>

										<div className="billing-credits__stat billing-credits__stat--highlight">
											<div className="billing-credits__stat-label">
												Remaining
											</div>
											<div className="billing-credits__stat-value billing-credits__stat-value--emphasis">
												{_formatNumber(tokensRemaining)}
											</div>
											<div className="billing-credits__stat-sub">
												tokens left this month
											</div>
										</div>
									</div>
									<hr />
									<div className="billing-credits__progress-wrapper">
										<DataCreditUsageProgress
											credit_total={creditsAllowed}
											credit_used={tokensUsed}
											usage
										/>
									</div>
								</CardBody>
							</Card>
						</Col>

						{/* Premium Credits card */}
						<Col md={6} className="mb-3">
							<Card>
								<CardBody className="billing-credits__card billing-credits__card--premium">
									<div className="billing-credits__header">
										<h6 className="billing-credits__section-title">
											Premium Credits
										</h6>
										<span className="billing-credits__badge billing-credits__badge--premium">
											Never Expires
										</span>
									</div>

									<p className="billing-credits__section-description">
										Premium Credits <strong>unlock high-value content</strong> such as contact emails, phone numbers, owner profiles and true owners behind LLCs. They <strong>never expire</strong> and are purchased separately from your subscription.
									</p>
									<hr />
									<div className="billing-credits__summary billing-credits__summary--premium">
										<div className="billing-credits__stat billing-credits__stat--highlight">
											<div className="billing-credits__stat-label">
												Premium Credits Available
											</div>
											<div className="billing-credits__stat-value billing-credits__stat-value--emphasis">
												{_formatNumber(premiumCreditsBalance)}
											</div>
											<div className="billing-credits__stat-sub">
												used for enhanced features
											</div>
										</div>
									</div>
									<hr />
									<div className="billing-premium__actions">
										<PremiumCreditsPurchaseModal
											source="billing"
											renderButton={(btnProps) => (
												<MuiButton
													variant="contained"
													color="primary"
													className="billing-premium__buy-button"
													onClick={btnProps.onClick}
												>
													Buy Premium Credits
												</MuiButton>
											)}
											onConfirm={(selectedPack, done) => {
												done();
											}}
										/>
									</div>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</CardBody>
			</Card>
		</Col>
	)
};

const form = 'password_form';

export default connect(
  (state, props) => {
  const initalValues = Object.assign({}, props.user);
  console.log(initalValues);
  return {
    initialValues: Object.assign({}, initalValues), // pull initial values from account reducer
    formValues: getFormValues(form)(state),
    user: state.user,
  }}
)(reduxForm({
  form: form, // a unique identifier for this form
})(DataUsage));
